/* eslint-disable indent */
/* eslint-disable prettier/prettier */
/* eslint-disable no-mixed-spaces-and-tabs */
/**
 * Created on 11/14/2019.
 */

import React from 'react';
import styled from 'styled-components';
import {currentResource, labels} from '../../../util/utils';
import Tooltip from '../BaseComponentWrappers/MotifTooltip';
import {inherentRiskTypeId as inherentRiskTypes} from '../../../util/uiconstants';
import Icon from '../BaseComponentWrappers/MotifIcon';
import {IconoirCustomRiskBolt} from '@ey/motif-react-wrapper/assets/icons/custom';

export default function CRABadges(props) {
	const {
		assertionsId,
		assertionname,
		assertionAbbreviation,
		craValue,
		inherentRiskTypeId,
		controlRiskTypeId,
		hasRiskAssociated,
		validationStatus,
		validationMessages,
		notForDisplay,
		noBackground,
		showAbbreviationTooltipOnly,
		noBackgroundYesTooltip,
		inherentRiskView
	} = props;

	const craVal = craValue ? craValue.split(' ')[0] : '';

	const getBoltClass = (craValue, hasRiskAssociated, inherentRiskView) => {
		if (inherentRiskView && hasRiskAssociated) {
			return 'lightningbolt purple';
		}
		if (!hasRiskAssociated) {
			return '';
		}
		let assertionThunderClass = '';
		switch (craValue.toLowerCase()) {
			case 'low':
				assertionThunderClass = 'lightningbolt yellow';
				break;
			case 'moderate':
				assertionThunderClass = 'lightningbolt orange';
				break;
			case 'high':
				assertionThunderClass = 'lightningbolt red';
				break;
			case '':
				assertionThunderClass = 'lightningbolt charcoal';
				break;
			default:
				assertionThunderClass = 'lightningbolt charcoal';
		}
		return assertionThunderClass;
	};

	const getCRAClass = (craValue, validationStatus, validationMessages, inherentRiskView) => {
		let assertionClass = '';
		if (inherentRiskView) {
			switch (inherentRiskTypeId) {
				case inherentRiskTypes.HIGHER:
					assertionClass = 'cra-incomplete-IR';
					break;
				case inherentRiskTypes.LOWER:
					assertionClass = 'no-cra-low-IR';
					break;
				default:
					assertionClass = 'no-cra-diagnostic-IR';
			}
			return assertionClass;
		}
		switch (craValue.toLowerCase()) {
			case '':
				assertionClass = validationStatus ? 'no-cra-diagnostic' : 'no-cra';
				break;
			case 'minimal':
				assertionClass = 'cra-minimal';
				break;
			case 'low':
				assertionClass = 'cra-low';
				break;
			case 'moderate':
				assertionClass = 'cra-moderate';
				break;
			case 'high':
				assertionClass = 'cra-high';
				break;
			case 'no-cra-diagnostic':
				assertionClass = 'no-cra-diagnostic';
				break;
			default:
				assertionClass = 'no-cra';
		}

		//if cravalue has a value and validationstatus is true ,
		//and contains validation message,
		//then display no cra diagonstic css
		/*ignore jslint start*/
		if (craValue && validationStatus && validationMessages && validationMessages.length > 0) {
			assertionClass = 'no-cra-diagnostic';
		}
		return assertionClass;
	};

	let assertionClass = getCRAClass(craVal, validationStatus, validationMessages, inherentRiskView);

	const assertionBoltClass = getBoltClass(craVal, hasRiskAssociated, inherentRiskView);

	if (noBackground && noBackground === true) {
		assertionClass = ' noBackground ';
	}
	if (noBackgroundYesTooltip && noBackgroundYesTooltip === true) {
		if (inherentRiskView) {
			assertionClass = ' no-cra-low-IR';
		} else {
			assertionClass = ' no-cra ';
		}
	}

	return (
		<Wrapper className={`craBadgesWrapper ${assertionClass}`}>
			{notForDisplay === true ? (
				<span>filler</span>
			) : showAbbreviationTooltipOnly ? (
				<section
					title={
						currentResource.assertions && currentResource.assertions[assertionsId - 1]
							? currentResource.assertions[assertionsId - 1].assertionname
							: assertionAbbreviation && assertionAbbreviation.replace('&amp;', '&').replace('&AMP;', '&')
					}
					className={`assertion ${assertionClass}`}
				>
					{currentResource.assertions && currentResource.assertions[assertionsId - 1]
						? currentResource.assertions[assertionsId - 1].assertionabbreviation
						: assertionAbbreviation && assertionAbbreviation.replace('&amp;', '&').replace('&AMP;', '&')}
				</section>
			) : (
				<Tooltip
					id="auto"
					className={'assertionToolTip'}
					variant="alt"
					placement="auto"
					hideCloseButton
					trigger={
						<>
							<section className={`assertion ${assertionClass}`}>
								{currentResource.assertions && currentResource.assertions[assertionsId - 1]
									? currentResource.assertions[assertionsId - 1].assertionabbreviation
									: assertionAbbreviation && assertionAbbreviation.replace('&amp;', '&').replace('&AMP;', '&')}
							</section>
							{!noBackground && assertionBoltClass && (
								<sup className="sup-thunder">
									<span className={`${assertionBoltClass}`} name="flashicon">
										<Icon className="small" size="16" src={IconoirCustomRiskBolt} title={labels.relatedRisks} />
									</span>
								</sup>
							)}
						</>
					}
					children={
						!noBackground && (
							<>
								<h4 className="risk-Type-Header">
									{currentResource.assertions && currentResource.assertions[assertionsId - 1]
										? currentResource.assertions[assertionsId - 1].assertionname
										: assertionname}
								</h4>
								<ul className="assertionsList">
									<li>
										<span className="risk-Type-Label">{`${labels.ir}:`}</span>
										<span className="risk-Type-Value">
											{inherentRiskTypeId
												? currentResource.inherentRiskType[inherentRiskTypeId - 1].name
												: labels.incomplete}
										</span>
									</li>
									{!inherentRiskView && (
										<>
											<li>
												<span className="risk-Type-Label">{`${labels.cr}:`}</span>
												<span className="risk-Type-Value">
													{controlRiskTypeId
														? currentResource.controlRiskType[controlRiskTypeId - 1].name
														: labels.incomplete}
												</span>
											</li>
											<li>
												<span className="risk-Type-Label">{`${labels.cra}:`}</span>
												<span className="risk-Type-Value">
													{craValue ? currentResource.CRAStrings[craValue] : labels.incomplete}
												</span>
											</li>
										</>
									)}
								</ul>
							</>
						)
					}
				/>
			)}
		</Wrapper>
	);
}

const Wrapper = styled.section`
	position: relative;
	margin: 0;
	min-width: var(--px-60);
	cursor: pointer;
	display: inline-flex;
	align-items: center;
	&.noBackground {
		pointer-events: none;
	}
	sup {
		display: inline-flex;
		top: 0;
	}
	.assertion {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		line-height: normal;
		min-width: var(--px-44);
		min-height: var(--px-24);
		border: var(--px-1) solid #c3c3cb;
		border-radius: var(--px-4);
		color: #c3c3cb;
		text-align: center;
		font-weight: 400;
		font-size: var(--px-12);
		text-transform: uppercase;
		padding: var(--px-2) 0;
		&.no-cra {
			background: var(--neutrals-00white);
			border-color: #afaeba;
			color: #afaeba;
		}
		&.cra-minimal {
			background-color: #d7d7dc;
			border-color: #000;
			color: #000;
		}
		&.cra-low {
			background-color: #ffe600;
			border-color: #ffe600;
			color: #000;
		}
		&.cra-high {
			background-color: #ff4136;
			border-color: #ff4136;
			color: #fff;
		}
		&.cra-moderate {
			background-color: #ee8300;
			border-color: #ee8300;
			color: #fff;
		}
		&.no-cra-diagnostic {
			border: var(--px-1) solid #ff4136;
			color: #ff4136;
		}
		&.no-cra-low-IR {
			background: var(--neutrals-00white);
			border: var(--px-2) solid #b14891;
			color: var(--neutrals-1000);
		}
		&.no-cra-diagnostic-IR {
			background: var(--neutrals-00white);
			border: var(--px-2) dashed #656579;
			color: #656579;
		}
		&.cra-incomplete-IR {
			background: #b14891;
			border-color: #b14891;
			color: #fff;
		}
	}
	.lightningbolt {
		position: relative;
		svg {
			height: var(--px-16);
			width: var(--px-16);
		}
		&.yellow {
			svg {
				color: #ffe600;
				path {
					fill: currentColor;
				}
			}
		}
		&.red {
			svg {
				color: #ff4136;
				path {
					fill: currentColor;
				}
			}
		}
		&.orange {
			svg {
				color: #ee8300;
				path {
					fill: currentColor;
				}
			}
		}
		&.charcoal {
			svg {
				color: var(--neutrals-800);
				path {
					fill: currentColor;
				}
			}
		}
		&.purple {
			svg {
				color: #b14891;
				path {
					fill: currentColor;
				}
			}
		}
	}
`;
